
import InfoPopup from "./InfoPopup";
import styles from "./ProjectButton.module.css"


export default function ProjectButton ({link, name, disabled=false, reason=""}) {

    if (disabled) return (
        <InfoPopup info={reason}>
            <span className={`${styles.projectButton} ${styles.disabled}`}>
                {name}
            </span>
        </InfoPopup>
    );


    return (
        <a href={link} target="_blank" rel="noopener noreferrer" className={styles.projectButton}>{name}</a>
        
    );
}